import { NewEventNameModal } from "./NewEventNameModal";

export default NewEventNameModal;
